export default "__VITE_ASSET__BswZmuqA__"